module.exports = __webpack_public_path__ + "img/circle_later.921ed824.svg";